<template>
  <b-container class="edit-coordinator" fluid>
    <div id="coordinator">
      <h1 class="title">Edit Coordinator</h1>
      <div id="alerts">
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
          >You have successfully edited this coordinator!</b-alert
        >
        <b-alert :show="showError" dismissible variant="warning"
          >Something went Wrong. Please refresh and try again.</b-alert
        >
      </div>
      <b-row>
        <b-col>
          <active-input plural="coordinators" singular="coordinator"></active-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <basic-info singular="coordinator" plural="coordinators"></basic-info>
        </b-col>
        <b-col>
          <coordinator-designation></coordinator-designation>
        </b-col>
        <b-col>
          <contact-info singular="coordinator" plural="coordinators"></contact-info>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <geo-info
            plural="coordinators"
            parent="et"
            singular="coordinator"
            :coords="false"
          ></geo-info>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <coordinator-education></coordinator-education>
        </b-col>
      </b-row>
      <br />
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Coordinator's Teams" active>
            <div class="coordinator-teams">
              <h4 class="sub-title">Coordinator's Teams</h4>
              <coordinator-teams id="coordinator-teams"></coordinator-teams>
            </div>
          </b-tab>
          <b-tab title="Coordinator's Trainers">
            <div class="coordinator-trainers">
              <h4 class="sub-title">Coordinator's Trainers</h4>
              <coordinator-trainers id="coordinator-trainers"></coordinator-trainers>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
      <confirm-submit></confirm-submit>
      <b-button
        :size="'lg'"
        :variant="'primary'"
        class="app_coordinator_btn mb-4"
        @click.prevent="updateCoordinator"
        :disabled="isDisabled"
        >Edit Coordinator</b-button
      >
    </div>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import SchoolService from '@/services/SchoolService';
import BasicInfo from '@/components/BasicInfo';
import CoordinatorDesignation from '@/components/CoordinatorDesignation';
import CoordinatorEducation from '@/components/CoordinatorEducation';
import CoordinatorTrainers from '@/components/CoordinatorTrainers';
import CoordinatorTeams from '@/components/CoordinatorTeams';
import TeacherSupport from '@/components/TeacherSupport';
import ConfirmSubmit from '@/components/ConfirmSubmit';
import ContactInfo from '@/components/ContactInfo';
import GeoInfo from '@/components/GeoInfo';
import TrainingModules from '@/components/TrainingModules';
import ActiveInput from '@/components/ActiveInput';

export default {
  name: 'EditCoordinator',
  components: {
    BasicInfo,
    CoordinatorDesignation,
    CoordinatorEducation,
    CoordinatorTrainers,
    CoordinatorTeams,
    ContactInfo,
    GeoInfo,
    TrainingModules,
    ConfirmSubmit,
    TeacherSupport,
    ActiveInput,
  },
  data() {
    return {
      showError: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      isDisabled: false,
    };
  },
  methods: {
    ...mapActions({
      RESET_COORDINATORS_STATE: 'coordinators/RESET_COORDINATORS_STATE',
      GET_COORDINATOR: 'coordinators/GET_COORDINATOR',
      UPDATE_COORDINATOR: 'coordinators/UPDATE_COORDINATOR',
    }),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    flashSuccess() {
      this.dismissCountDown = this.dismissSecs;
    },
    flashError() {
      this.showError = !this.showError;
    },
    async updateCoordinator() {
      if (!this.$store.state.confirmed) {
        alert('Please confirm the information above is correct');
        return;
      }
      if (
        this.$store.state.coordinators.coordinator.first_name.length === 0 ||
        this.$store.state.coordinators.coordinator.last_name.length === 0 ||
        this.$store.state.coordinators.coordinator.sex.length === 0
      ) {
        window.scrollTo(0, 0);
        this.flashError();
      } else {
        this.isDisabled = true;
        await this.UPDATE_COORDINATOR();
        window.scrollTo(0, 0);
        await this.flashSuccess();
        await this.$store.commit('resetConfirmed');
        await this.RESET_COORDINATORS_STATE();
        setTimeout(() => {
          this.$router.push('/coordinators');
        }, 1500);
      }
    },
  },
  computed: {
    coordinator: {
      get() {
        return this.$store.state.coordinators.coordinator;
      },
    },
  },
  created() {
    console.log("creating edit Trainer");
    this.GET_COORDINATOR(this.$route.params.id);
  },
};
</script>

<style scoped>
#coordinator {
  width: 75%;
  white-space: nowrap;
  margin: 0 auto;
  text-align: center;
}
.form div {
  margin: 20px;
}
.app_coordinator_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
.assigned-schools {
  list-style-type: none;
  display: inline;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}

div#assigned-schools,
#obs {
  float: left;
  padding: 1%;
}
</style>
